import { ROLES } from "../../const/roles"
import type { ApiRoleStrategy } from "../../hooks"

const queryKey = ["upps", "dataref"]
const endpoint = "/api/upps/dataref?size=-1"

export const uppDataRefApiRoleConf = (): ApiRoleStrategy => ({
  [ROLES.ADMIN]: { queryKey, endpoint },
  [ROLES.ADHERENT_HOLDER]: { queryKey, endpoint },
  [ROLES.ADHERENT_TEAM]: { queryKey, endpoint },
  [ROLES.ADHERENT_ADVISOR]: { queryKey, endpoint },
  [ROLES.EXTERN_CONTACT_LABORATORY]: { queryKey, endpoint },
})
